<template>
	<CModal
		:show.sync="isShow"
		:close-on-backdrop="false"
		centered
		class="modal-sku"
	>
		<template #header-wrapper>
			<ModalHeaderWrapper
				:title="title"
				@onClose="handleCancel"
			/>
		</template>
		<template #default>
			<CForm @submit.prevent="handleSubmit">
				<CRow
					:gutters="false"
					align-horizontal="between"
				>
					<CCol>
						<CInput
							v-model.trim="inputSKU"
							:placeholder="$t('placeholder.sku_number')"
							class="mb-2"
						/>
					</CCol>
					<div class="action">
						<CButton
							type="submit"
							color="secondary"
							class="transparent"
							block
						>
							{{ $t('button.add') }}
						</CButton>
					</div>
				</CRow>
			</CForm>
			<section>
				<CRow>
					<CCol>
						<p class="typo-helper-text text-black-45">
							{{ $t('message.use_semicolon_to_input_multiple_items') }}
						</p>
					</CCol>
				</CRow>
			</section>
			<section>
				<CRow
					v-if="skuIds.length"
				>
					<CCol xl="12">
						<p class="typo-label mb-1">
							{{ $t('message.sku') }}
						</p>
					</CCol>
					<CCol class="container-skus">
						<span class="container-skus-item typo-helper-text text-black-45">
							{{ showText }}
						</span>
					</CCol>
				</CRow>
				<CRow
					v-else
				>
					<CCol class="container-skus d-flex align-items-center text-center">
						<div class="col">
							<p class="typo-h6 text-black-45 mb-0">
								{{ $t('message.no_sku_yet') }}
							</p>
							<p class="typo-body-2 text-black-45">
								{{ $t('message.add_sku_number_in_order_to_set_condition') }}
							</p>
						</div>
					</CCol>
				</CRow>
			</section>
		</template>
		<template #footer>
			<BaseModalFooter
				:total-select="totalSelect"
				:disabled-comfirm="isSubmitting"
				:disabled-cancel="isSubmitting"
				:disabled-clear="isSubmitting"
				:is-show-clear="isShowClear"
				@onClear="handleClear"
				@onCancel="handleCancel"
				@onConfirm="handleConfirm"
			/>
		</template>
	</CModal>
</template>

<script>
import { cloneDeep, numberFormat } from '../helpers/utils';

export default {
	props: {
		title: {
			type: String,
			default: null,
		},
		selectedIds: {
			type: Array,
			default: () => [],
		},
	},

	data() {
		return {
			isShow: false,
			inputSKU: '',
			skuIds: [],
		};
	},

	computed: {
		isSubmitting() {
			return this.isLoading;
		},
		totalSelect() {
			return numberFormat(this.skuIds.length);
		},
		isShowClear() {
			return this.skuIds.length > 0;
		},
		showText() {
			return this.skuIds.join('; ');
		},
	},

	created() {
		// set default state
		this.skuIds = cloneDeep(this.selectedIds);
	},

	methods: {
		resetState() {
			this.inputSKU = '';
			this.skuIds = cloneDeep(this.selectedIds);
		},
		open() {
			this.isShow = true;
			this.resetState();
		},
		close() {
			this.isShow = false;
		},
		handleClear() {
			this.inputSKU = '';
			this.skuIds = [];
		},
		getListFromInputSKU(inputSKU) {
			let list = inputSKU.split(';');

			// trim all items and remove null
			list = list.map((item) => item.trim()).filter((item) => item);

			// remove duplicates
			return [...new Set(list)];
		},
		handleConfirm() {
			this.$emit('onSubmit', false, this.skuIds.length, cloneDeep(this.skuIds));
			this.close();
		},
		handleSubmit() {
			if (!this.inputSKU) {
				return;
			}

			const mergedInput = `${this.showText}; ${this.inputSKU}`;
			this.skuIds = this.getListFromInputSKU(mergedInput);
			this.inputSKU = '';
		},
		handleCancel() {
			this.skuIds = cloneDeep(this.selectedIds);
			this.$emit('onCancel');
			this.close();
		},
	},
};
</script>

<style lang="scss" scoped>
.clear-button {
	cursor: pointer;
}

::v-deep .modal-dialog {
	max-width: rem(500);
}

::v-deep .container-skus {
	height: rem(272);
	overflow-x: hidden;
	overflow-y: scroll;

	&-item {
		margin-right: rem(3);
	}
}

.action {
	width: rem(80);
	margin-left: rem(16);
}
</style>
